import { doPost } from '../http/httpHelper';

export const exportExcelData = async (payload) => {
    const resp = await doPost('/ordersExport/export-excel-data', payload);
    return resp?.body ?? resp;
};
